import PickPackListDropdown from 'components/PickPackListDropdownt';
import React, { useState } from 'react';
import { addRoutesToPickPackList } from 'services';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const AddRouteToPickPackListModal = props => {
  const [selectedPickackListId, setSelectedPickackListId] = useState<string>('');
  const [pickPackList, setPickPackList] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [listSelected, setListSelected] = useState<boolean>(false);
  const { routeIds, onSuccess, toggleModal } = props;

  const addToPickPackList = async (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addRoutesToPickPackList(selectedPickackListId, routeIds);
      await onSuccess();
      showSuccess('Selected route(s) added to Pick Pack List successfully');
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const setPickPackListDetails = (list: Record<string, any>) => {
    const listData = {
      id: list.objectId,
      name: list.name,
      number: list.pickPackListNo,
      owner: list.owner.full_name,
      locked: list.locked.toString(),
    };
    setPickPackList(listData);
  };

  const handleSelect = (id: string) => {
    setSelectedPickackListId(id);
    setListSelected(true);
  };

  const ListDetails = () => (
    <div className={styles['list-details']}>
      <div className={styles['list-info-group']}>
        <div className={styles['label']}>Pick Pack List ID</div>
        <div className={styles['list-detail']}>{pickPackList.id}</div>
      </div>
      <div className={styles['list-info-group']}>
        <div className={styles['label']}>List Name</div>
        <div className={styles['list-name']}>{pickPackList.name}</div>
      </div>
      <div className={styles['list-info-group']}>
        <div className={styles['label']}>List No.</div>
        <div className={styles['list-name']}>{pickPackList.number || 'N/A'}</div>
      </div>
      <div className={styles['list-info-group']}>
        <div className={styles['label']}>List Owner</div>
        <div className={styles['list-name']}>{pickPackList.owner || 'N/A'}</div>
      </div>
      <div className={styles['list-info-group']}>
        <div className={styles['label']}>Locked</div>
        <div className={styles['list-name']}>{pickPackList.locked}</div>
      </div>
    </div>
  );

  return (
    <form onSubmit={addToPickPackList} className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Route</div>
            <div className={styles['modal-title']}>Add Route to Pick Pack List</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div>
            <div className={styles['label']}>Pick Pack List</div>
            <PickPackListDropdown
              disabled={loading}
              selectedList={selectedPickackListId}
              setListDetails={setPickPackListDetails}
              setSelectedList={handleSelect}
            />
          </div>
          {listSelected && <ListDetails />}
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type={'submit'}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default AddRouteToPickPackListModal;
